interface Props {
  id: string | null;
  name: string;
  active: boolean;
  onChange: (activeSubcategory: string | null) => void;
}

export default function FilterChip(props: Props) {
  const handleSelectSubcategory = () => props.onChange(props.id);

  return (
    <li className="shrink-0">
      <label className="block mb-0">
        <input
          type="radio"
          className="hidden peer"
          name="subcategory"
          checked={props.active}
          onChange={handleSelectSubcategory}
        />
        <p className="peer-checked:bg-greyscale-pink peer-checked:border-secondary peer-checked:text-secondary py-2 px-3 border border-greyscale-label text-greyscale-label rounded-full text-base mb-0 cursor-pointer font-medium">
          {props.name}
        </p>
      </label>
    </li>
  );
}
